import { createBlock } from 'factories/block';
import { createLayout } from 'factories/layout';
import { createContinueBtn } from './continueBtn';
import { getSId } from '../utils';
import { Block, cloneBlock, Blocks } from 'factories/block';
import { flatten } from 'factories/utils';
import { createMediaBlock } from './media';
import { getPlaceholderText } from './text';

export const addTopicPortalMedia = (
  block: Block,
  position: number,
  { topicId, topicSId }
): [Block, Blocks?] => {
  if (block.type === 'TopicPortalContainer') {
    const topicPortalMediaBlock = createBlock(
      'TopicPortalMedia',
      [
        createMediaBlock({
          src: undefined,
          child: 1,
          fit: 'cover',
          useBackgroundControls: false,
        }),
        createMediaBlock({
          src: undefined,
          child: 0,
          fit: 'cover',
          useBackgroundControls: false,
          bulletColor: '#fff',
        }),
      ],
      {
        props: {
          topicId,
          topicSId,
        },
      }
    );

    const topicPortalMediaBlockRef = {
      id: topicPortalMediaBlock.id,
      type: 'Ref',
    };

    const [newBlocks] = flatten(topicPortalMediaBlock);

    const nextBlock = cloneBlock(block);

    (nextBlock.children as Block[]).splice(
      position,
      0,
      topicPortalMediaBlockRef
    );

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const removeTopicPortalMedia = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'TopicPortalContainer') {
    const topicPortalMediaBlock = createBlock('TopicPortalMedia', [
      createMediaBlock({
        src: undefined,
        child: 1,
        fit: 'cover',
        useBackgroundControls: false,
      }),
      createMediaBlock({
        src: undefined,
        child: 0,
        fit: 'cover',
        useBackgroundControls: false,
        bulletColor: '#fff',
      }),
    ]);

    const [newBlocks] = flatten(topicPortalMediaBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 1);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

const contentForColumn = (count: number) => (i: number) => {
  return [
    () =>
      createMediaBlock({
        child: 0,
        imgPlaceholderIndex: 1,
        textPlaceholderContent: getPlaceholderText('h2', 'heading-two'),
        className: 'text-align-center',
      }),
    () =>
      createBlock('InteractionColumn', [
        createBlock('TopicPortalContainer', [], {}),
        createMediaBlock({
          child: 0,
          isAdditionalMedia: true,
        }),
      ]),
  ][i];
};

export const createTopicPortalInteractionBlock = props => {
  const { style } = props as any;

  //

  return createBlock(
    'Interaction',
    [
      createLayout(contentForColumn(0), 0, true),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
      },
      meta: {
        subType: 'TopicPortal',
        layout: 'OneColumnReversed',
      },
    }
  );
};

export const create = createTopicPortalInteractionBlock;
export const interactionConfig = {};
